import i18n from "i18next";
import { CountryPath } from "src/entities/CountryPath";

const getCountryLanguage = (countryPath: CountryPath) => {
  let languageKey: string;

  switch (countryPath) {
    case "IDN":
      languageKey = "languages.bahasa_indonesia";
      break;
    case "SGP":
    case "PHL":
    case "MYS":
    case "AUS":
    case "USA":
      languageKey = "languages.english";
      break;
    case "THA":
      languageKey = "languages.thai";
      break;
    case "VNM":
      languageKey = "languages.vietnamese";
      break;
    case "JPN":
      languageKey = "languages.japanese";
      break;
    default:
      return "Unknown";
  }

  // Try to get translated language name
  const translated = i18n.t(languageKey);

  // If translation exists (not equal to the key), return it
  if (translated !== languageKey) {
    return translated;
  }

  // Fallback to English names
  switch (countryPath) {
    case "IDN":
      return "bahasa Indonesia";
    case "SGP":
    case "PHL":
    case "MYS":
    case "AUS":
    case "USA":
      return "English";
    case "THA":
      return "Thai";
    case "VNM":
      return "Vietnamese";
    case "JPN":
      return "Japanese";
    default:
      return "Unknown";
  }
};

export default getCountryLanguage;
